import React, { useState, useEffect } from 'react';
import { TinyCommunity } from 'types/company/community';
import { useHistory, useLocation } from 'react-router';
import { BODY_ID } from 'ui/views/layouts/BaseLayout/ScrollableBody';
import PostUpdateDialog from './PostCommunityUpdateDialog';
import useCommunityRole from 'hooks/useCommunityRole';
import { canPostCommunityUpdate } from './utils';
import PostUpdateField from '../shared/PostUpdateField';
import { usePostAs } from './PostCommunityUpdateDialog/usePostAs';

export default function PostUpdate({
  community,
  updatesRef,
}: {
  community: TinyCommunity;
  updatesRef: React.RefObject<HTMLDivElement>;
}) {
  const { hasScope, roles } = useCommunityRole(community.slug);

  const canPostUpdate = canPostCommunityUpdate(hasScope, roles);
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const isPostingUpdate = params.get('writeUpdate') === '1';
  const [isOpen, setIsOpen] = useState(isPostingUpdate);

  // Update the dialog state when URL changes
  useEffect(() => {
    setIsOpen(isPostingUpdate);
  }, [isPostingUpdate]);

  const scrollToUpdatesSection = () => {
    if (updatesRef.current) {
      const updatesPosition = updatesRef.current.offsetTop;
      const body = document.getElementById(BODY_ID);
      body?.scrollTo({ top: updatesPosition - 30, behavior: 'smooth' });
    }
  };

  const { author } = usePostAs(community);

  const history = useHistory();
  const queryParams = new URLSearchParams(location.search);

  function removeUrlParam(param: string) {
    if (queryParams.has(param)) {
      queryParams.delete(param);
      history.replace({
        search: queryParams.toString(),
      });
    }
  }

  return (
    <>
      {canPostUpdate && (
        <div data-intercom-target="community-post-updates" className="u-content-spacing-bottom">
          <PostUpdateDialog
            isOpen={isOpen}
            community={community}
            onUpdatePosted={() => {
              scrollToUpdatesSection();
            }}
            onClose={() => {
              setIsOpen(false);
              // To make the checklist on the company page open the update dialog after closing it, we need to reset the url
              removeUrlParam('writeUpdate');
            }}
          />
          <PostUpdateField author={author} onClick={() => setIsOpen(true)} />
        </div>
      )}
    </>
  );
}
